export let memberCountPlural = "v2gGRd";
export default {memberCountPlural};